export default __webpack_public_path__ + "static/media/eyes.207321db.svg";